import React, { useEffect } from 'react';
import { string, arrayOf } from 'prop-types';
import LinkBox from '../LinkBox/index.jsx';
const TRACKING_PIXEL_GTM_EVENT = 'Tracking Pixel';

/**
 * SponsorTracking component.
 */
const SponsorTracking = ({
  label,
  pixels
}) => {
  useEffect(() => {
    if (pixels !== null && pixels.length > 0) {
      window.dataLayer = window.dataLayer || [];
      pixels.forEach(url => {
        window.dataLayer.push({
          event: TRACKING_PIXEL_GTM_EVENT,
          url
        });
      });
    }
  }, []);
  if (!label) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(LinkBox, {
    bgColor: "commercialRegular",
    color: "baseWhite",
    rel: "nofollow",
    text: label
  }));
};
SponsorTracking.defaultProps = {
  label: '',
  pixels: null
};
SponsorTracking.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Sponsor tracking label. */
  label: string,
  /** Sponsor tracking pixels. */
  pixels: arrayOf(string)
} : {};
export default SponsorTracking;